export default "__VITE_ASSET__BrYTdZzB__"